import type { LegalDocument } from "./legal-types";
import { LEGAL_COMPANY_CONTACT, LEGAL_COMPANY_NAME, LEGAL_DPO_EMAIL } from "./legal-meta";

const termsOfUsePtBr: LegalDocument = {
  id: "terms",
  title: "Termos de Uso",
  disclaimer:
    "Este documento descreve as condições de uso do aplicativo Innovally. Ao utilizar o aplicativo, você declara ter lido e concordado com estes Termos de Uso.",
  sections: [
    {
      id: "acceptance",
      title: "Aceitação e elegibilidade",
      audiences: ["ALL"],
      paragraphs: [
        "Estes Termos regulam o uso do aplicativo Innovally por usuários autorizados por um estabelecimento parceiro.",
        "O acesso é concedido mediante credenciais fornecidas pelo estabelecimento. Você deve ser maior de 18 anos ou possuir autorização legal para utilizar o serviço.",
        "Ao acessar o aplicativo, você concorda com estes Termos e com a Política de Privacidade.",
      ],
    },
    {
      id: "service-motoboy",
      title: "Serviço — Motoboy",
      audiences: ["MOTOBOY"],
      paragraphs: [
        "O perfil Motoboy permite visualizar entregas atribuídas, acompanhar status, registrar início e conclusão com localização, abrir rotas em apps de mapa e receber alertas de novas entregas.",
        "Você é responsável por conduzir entregas com segurança, respeitar dados de clientes e utilizar localização apenas para fins operacionais do serviço.",
      ],
    },
    {
      id: "service-lojista",
      title: "Serviço — Lojista e Sub Lojista",
      audiences: ["LOJISTA", "SUB_LOJISTA"],
      paragraphs: [
        "O perfil Lojista e Sub Lojista permite gerenciar pedidos, clientes, caixa, relatórios, configurações do estabelecimento, impressão de comprovantes e compartilhamento de link da loja.",
        "Sub Lojistas operam conforme permissões definidas pelo estabelecimento titular da conta.",
        "Você é responsável pelo tratamento adequado dos dados de clientes finais inseridos ou gerenciados na plataforma, em conformidade com a LGPD.",
      ],
    },
    {
      id: "account",
      title: "Conta e credenciais",
      audiences: ["ALL"],
      paragraphs: [
        "Mantenha login e senha em sigilo. Notifique imediatamente o estabelecimento ou a Innovally em caso de uso não autorizado.",
        "Você é responsável por atividades realizadas com sua conta, salvo comunicação tempestiva de comprometimento.",
      ],
    },
    {
      id: "conduct",
      title: "Conduta do usuário",
      audiences: ["ALL"],
      paragraphs: ["É proibido:"],
      bullets: [
        "Compartilhar credenciais ou permitir acesso de terceiros não autorizados.",
        "Utilizar o app para fins ilícitos ou em desacordo com estes Termos.",
        "Copiar, extrair ou divulgar dados de clientes ou do estabelecimento sem autorização.",
        "Tentar burlar medidas de segurança ou acessar áreas restritas do sistema.",
        "Utilizar dados de localização ou de clientes para finalidades alheias à operação de delivery.",
      ],
    },
    {
      id: "ip",
      title: "Propriedade intelectual",
      audiences: ["ALL"],
      paragraphs: [
        `Marcas, logotipos, layout e software do aplicativo são de titularidade de ${LEGAL_COMPANY_NAME} ou de seus licenciadores.`,
        "Estes Termos não concedem licença de propriedade intelectual além do uso necessário para operar o serviço.",
      ],
    },
    {
      id: "liability",
      title: "Limitações de responsabilidade",
      audiences: ["ALL"],
      paragraphs: [
        "O aplicativo é fornecido para apoiar a operação de delivery e gestão do estabelecimento. Interrupções por manutenção, falhas de rede ou casos fortuitos podem ocorrer.",
        `${LEGAL_COMPANY_NAME} não se responsabiliza por atos de terceiros (clientes finais, apps de mapa, operadoras) nem por danos indiretos decorrentes do uso inadequado do serviço.`,
        "Nada nestes Termos limita direitos irrenunciáveis previstos na legislação consumerista ou de proteção de dados, quando aplicáveis.",
      ],
    },
    {
      id: "termination",
      title: "Suspensão e encerramento",
      audiences: ["ALL"],
      paragraphs: [
        "O estabelecimento ou a Innovally podem suspender ou encerrar o acesso em caso de violação destes Termos, risco à segurança ou encerramento contratual.",
        "Você pode deixar de utilizar o aplicativo a qualquer momento; dados tratados seguirão a Política de Privacidade.",
      ],
    },
    {
      id: "law",
      title: "Lei aplicável e foro",
      audiences: ["ALL"],
      paragraphs: [
        "Estes Termos são regidos pelas leis da República Federativa do Brasil.",
        "Fica eleito o foro da comarca de Belo Horizonte/MG, salvo disposição legal em contrário.",
      ],
    },
    {
      id: "changes",
      title: "Alterações dos Termos",
      audiences: ["ALL"],
      paragraphs: [
        "Podemos alterar estes Termos periodicamente. A versão vigente estará disponível nesta página com a data de atualização.",
        "O uso continuado após alterações relevantes constitui concordância com a nova versão, ressalvado direito de revogar consentimentos conforme a LGPD.",
      ],
    },
    {
      id: "contact",
      title: "Contato",
      audiences: ["ALL"],
      paragraphs: [
        `Dúvidas sobre estes Termos: ${LEGAL_COMPANY_CONTACT}`,
        `Assuntos de privacidade e dados pessoais: ${LEGAL_DPO_EMAIL}`,
        LEGAL_COMPANY_NAME,
      ],
    },
  ],
};

export { termsOfUsePtBr };
